module.exports = __webpack_public_path__ + "RENAULT-logo.png";